;(() => {
	const attachBanner = (el = null) => {
		const banner = generateBanner()
		const intros = el.querySelectorAll('.article-intro')

		if (intros.length >= 7) {
			el.insertBefore(banner, intros[6])
		} else {
			el.insertBefore(banner, el.querySelector('.adsense2'))
		}
	}

	const generateBanner = () => {
		const cssClass = 'banner-ebike-rental'
		const node = document.createElement('div')
		node.classList.add(cssClass)
		node.classList.add('dkreset')

		node.innerHTML = `
			<a href="${mL('url')}" target="_blank" class="${cssClass}__content">
				<div class="${cssClass}__text">
					<p class="${cssClass}__title">${mL('title')}</p>
					<p class="${cssClass}__copy">${mL('copy')}</p>
				</div>
				<button type="button" class="${cssClass}__btn">${mL('scopri')}</button>
			</a>
		`
		node.querySelector('a').style.backgroundImage =
			"url('../images/mountain_bike/banner-ebike-rental.jpg')"

		return node
	}

	const mL = string => {
		const lang = WC?.lang ? WC.lang.substring(0, 2) : 'it'

		const data = {
			url: {
				it: '/it/e-bike/#ebike-rental',
				en: '/en/e-bike/#ebike-rental',
				de: '/de/e-bike/#ebike-rental',
			},
			title: {
				it: 'NOLEGGIA UNA E-BIKE',
				en: 'RENT AN E-BIKE',
				de: 'MIETEN SIE EIN E-BIKE',
			},
			copy: {
				it: "ed esplora l'Altopiano di Asiago",
				en: 'and explore the Asiago plateau',
				de: 'und erkunden Sie das Asiago-Plateau',
			},
			scopri: {
				it: 'Scopri',
				en: 'Discover',
				de: 'Entdecken',
			},
		}

		return data?.[string]?.[lang] || '???'
	}

	const el = document.querySelector('.body-page .riquadro')
	const sectionCheck = el?.querySelector('.article-intro')
	if (WC?.idMenu === 80 && el && sectionCheck) {
		attachBanner(el)
	}
})()
